import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Basket extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currency: "",
            channels: null,
            budget: null,
            plan: null,
            nextView: null,
            lockin: null,
            lockin_plan: {},
            duration: 0,
            vat: 0,
            min: 0,
            max: 0,
            spend: 0,
            durations: [],
            regions: [],
            servicefee_fixed: 0,
            servicefee_percentage: 0,
            inhouse: ""
        };
    };

    componentWillMount() {
        this.setState({
            channels: this.props.channels,
            budget: this.props.budget,
            duration: this.props.duration,
            durations: this.props.durations?this.props.durations.sort(function(a, b){return a - b}):[],
            currency: this.props.currency,
            plan: this.props.plan,
            vat: this.props.vat,
            props: this.props.props,
            lockin: this.props.lockin,
            lockin_plan: this.props.lockin_plan ? this.props.lockin_plan : {},
            regions: this.props.regions ? this.props.regions : [],
            nextView: this.props.nextView,
            servicefee_percentage: !this.props.serviceFeePercentage ? null : this.props.serviceFeePercentage,
            servicefee_fixed: !this.props.serviceFeeFixed ? null : this.props.serviceFeeFixed,
            inhouse: this.props.inhouse,
        }, () => {
            this._updateSpend();
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            budget: nextProps.budget,
            plan: nextProps.plan,
            regions: nextProps.regions ? nextProps.regions : [],
            lockin: nextProps.lockin,
            lockin_plan: nextProps.lockin_plan
        }, () => {
            this._updateSpend();
        })
    }

    _updateSpend() {
        let max = 0;
        let spend = 0;
        let min = 0;
        for (var key in this.state.channels) {
            if (this.state.channels[key].selected) {
                max = max + this.state.budget[key].budget;
                spend = spend + this.state.budget[key].spend;
                min = min + this.state.budget[key].min_budget;
            }
        }
        this.setState({min: min, max: max, spend: spend});
    }

    _decreaseDuration(){
        //this.state.durations.sort();
        var value = this.state.durations.indexOf(parseInt(this.state.duration));
        if(value > 0){
            this.setState({duration: this.state.durations[value - 1]}, () => {
                this.props.selectDuration(this.state.durations[value - 1]);
            });
        }
    }

    _increaseDuration(){
        //this.state.durations.sort();
        var value = this.state.durations.indexOf(parseInt(this.state.duration));
        if(value < this.state.durations.length - 1){
            this.setState({duration: this.state.durations[value + 1]}, () => {
                this.props.selectDuration(this.state.durations[value + 1]);
            });
        }
    }

    _decreaseAutoSpend(key) {
        try {
            if (this.state.regions.length > 0) {
                let spend = this.state.spend - 100;
                if ((spend - this.state.min) <= 0) {
                    this._setSpend(this.state.min);
                } else if (this.state.min <= spend) {
                    this._setSpend(spend);
                }
            }
        } catch (e) {}
    }

    _increaseAutoSpend(key) {
        try {
            if (this.state.regions.length > 0) {
                let spend = this.state.spend + 100;
                if (spend >= this.state.max) {
                    this._setSpend(this.state.max);
                } else if (this.state.max >= spend) {
                    this._setSpend(spend);
                }
            }
        } catch (e) {}
    }

    _setSpend(value) {
        try {
            let budget = value;
            for (var key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    this.state.budget[key].spend = this.state.budget[key].min_budget;
                    budget = budget - this.state.budget[key].spend;
                }
            }
            while (budget > 1) {
                for (var key in this.state.channels) {
                    if (this.state.channels[key].selected) {
                        let spend = this.state.budget[key].spend;
                        this.state.budget[key].spend = this.state.budget[key].spend + (budget * this.state.budget[key].allocation);
                        if (this.state.budget[key].spend > this.state.budget[key].budget) {
                            this.state.budget[key].spend = this.state.budget[key].budget;
                            budget = budget - (this.state.budget[key].budget - spend);
                        } else {
                            budget = budget - (budget * this.state.budget[key].allocation);
                        }
                    }
                }
            }
            let allocation = 0;
            let channel = null;
            for (var key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    if (this.state.budget[key].allocation > allocation && this.state.budget[key].spend < this.state.budget[key].budget) {
                        channel = key;
                    }
                }
            }
            this.state.budget[channel].spend = this.state.budget[channel].spend + budget;
            this.setState({spend: value, budget: this.state.budget}, () => {
                this.props.updateBudget(this.state.budget);
            });
        } catch (e) {
        }
    }

    _decreaseSpend(key) {
        try {
            if (this.state.regions.length > 0) {
                let spend = this.state.budget[key].spend - 100;
                if ((spend - this.state.budget[key].min_budget) <= 0) {
                    this.state.budget[key].spend = this.state.budget[key].min_budget;
                    this.setState({budget: this.state.budget}, () => {
                        this.props.updateBudget(this.state.budget);
                    });
                } else if (this.state.budget[key].min_budget <= spend) {
                    this.state.budget[key].spend = this.state.budget[key].spend - 100;
                    this.setState({budget: this.state.budget}, () => {
                        this.props.updateBudget(this.state.budget);
                    });
                }
            }
        } catch (e) {
        }
    }

    _increaseSpend(key) {
        try {
            if (this.state.regions.length > 0) {
                let spend = this.state.budget[key].spend + 100;
                if (spend >= this.state.budget[key].budget) {
                    this.state.budget[key].spend = this.state.budget[key].budget_available;
                    this.setState({budget: this.state.budget}, () => {
                        this.props.updateBudget(this.state.budget);
                    });
                } else if (this.state.budget[key].budget >= spend) {
                    this.state.budget[key].spend = this.state.budget[key].spend + 100;
                    this.setState({budget: this.state.budget}, () => {
                        this.props.updateBudget(this.state.budget);
                    });
                }
            }
        } catch (e) {
        }
    }

    _renderImpressionsBySpend() {
        let impressions = 0;
        if (this.state.budget && this.state.regions.length > 0) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    impressions = impressions + Math.ceil(this.state.budget[key].spend / this.state.budget[key].cpi);
                }
            }
            return impressions;
        } else {
            return (0);
        }
    }

    _renderLeadsBySpend() {
        let clicks = 0;
        if (this.state.budget && this.state.regions.length > 0) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    clicks = clicks + Math.ceil(this.state.budget[key].spend / this.state.budget[key].cpc);
                }
            }
            return clicks;
        } else {
            return (0);
        }
    }

    _renderImpressionsPartial(key) {
        let impressions = 0;
        if (this.state.budget && this.state.regions.length > 0) {
            impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
            return Math.ceil(impressions);
        } else {
            return (0);
        }
    }

    _renderLeadsPartial(key) {
        let clicks = 0;
        if (this.state.budget && this.state.regions.length > 0) {
            clicks = clicks + (this.state.budget[key].spend / this.state.budget[key].cpc);
            return Math.ceil(clicks);
        } else {
            return (0);
        }
    }

    _renderReach() {
        let reach = 0;
        for(let i = 0; i < this.state.regions.length; i++){
            try{
                if(this.state.regions[i].population){
                    reach = reach + parseFloat(this.state.regions[i].population.replace(/,/g, ''));
                }
            }catch (e) {
                try {
                    if(this.state.regions[i].population){
                        reach = reach + +this.state.regions[i].population;
                    }
                }catch (e) {

                }
            }
        }

        let channel_reach = 0;
        let allocations = {facebook: 0.5, google: 0.7, instagram: 0.25, bing: 0.03};
        //this.state.budget[key].allocation
        let highest_allocation = 0;
        for (let key in this.state.channels) {
            if(this.state.channels[key].selected){
                if(allocations[key] > highest_allocation){
                    highest_allocation = allocations[key];
                }
            }
        }

        channel_reach = channel_reach + (reach * highest_allocation);

        return Math.round(channel_reach);

    }

    _renderPartialBudget() {
        if (this.state.budget && this.state.channels && this.state.regions.length > 0) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }

            // IF FIXED FEE
            if (this.state.servicefee_fixed) {
                budget = budget + this._renderFixedFee();
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.servicefee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            //IF COMMISSION
            if (!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin) {
                budget = budget * this.state.lockin_plan.months;
            }

            //IF LOCKIN
            if (this.state.lockin) {
                budget = budget - this._renderDiscount();
            }

            //IF VAT
            if (this.state.vat && this.state.nextView === "/signup/payment") {
                budget = budget + this._renderVat();
            }

            return budget;
        } else {
            return 0;
        }
    }

    _renderFixedFee() {
        if (this.state.lockin && this.state.lockin_plan) {
            return this.state.servicefee_fixed * this.state.lockin_plan.months;
        } else {
            return this.state.servicefee_fixed
        }
    }

    _renderPercentageFee() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }
            if (this.state.lockin && this.state.lockin_plan) {
                return (budget * (this.state.servicefee_percentage / 100)) * this.state.lockin_plan.months;
            } else {
                return budget * (this.state.servicefee_percentage / 100);
            }
        }
    }

    _renderVat() {
        if (this.state.budget && this.state.channels) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }

            // IF FIXED FEE
            if (this.state.servicefee_fixed) {
                budget = budget + this._renderFixedFee();
            }

            //IF PERCENTAGE SERVICE FEE
            if (this.state.servicefee_percentage) {
                budget = budget + this._renderPercentageFee();
            }

            //IF COMMISSION
            if (!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin) {
                budget = budget * this.state.lockin_plan.months;
            }

            //IF LOCKIN
            if (this.state.lockin) {
                budget = budget - this._renderDiscount();
            }

            return budget * (+this.state.vat / 100);
        }
    }

    _renderDiscount() {
        if (this.state.lockin_plan) {
            let budget = 0;
            for (let key in this.state.budget) {
                try {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }catch (e) {}
            }
            if (this.state.servicefee_fixed) {
                return this.state.servicefee_fixed * this.state.lockin_plan.free_months;
            }
            else if (this.state.servicefee_percentage) {
                return (budget * (this.state.servicefee_percentage / 100)) * this.state.lockin_plan.free_months;
            } else {
                return budget * this.state.lockin_plan.free_months;
            }
        }
    }

    _renderChannelName(item){
        if(item === "facebook"){
            return "Facebook social"
        }else if(item === "instagram"){
            return "Instagram social"
        }else if(item === "google"){
            return "Google search"
        }else if(item === "bing"){
            return "Bing search"
        }
    }

    _renderChannelNameShort(item){
        if(item === "facebook"){
            return "social"
        }else if(item === "instagram"){
            return "social"
        }else if(item === "google"){
            return "search"
        }else if(item === "bing"){
            return "search"
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("signup-budget", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerRightItem}>
                {
                    this.state.budget && this.state.channels && this.state.plan &&
                    <div className={Styles.contentContainerRightItemInner}>
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.contentContainerRightItemHeader}>
                            {this._renderText("item_15")}
                        </div>
                        <div className={Styles.contentContainerRightItemReach}>
                            <div className={Styles.contentContainerRightItemReachInner}>
                                <div className={Styles.contentContainerRightItemReachInnerTitle}>
                                    {this._renderText("item_2")}
                                </div>
                                <div className={Styles.contentContainerRightItemReachInnerValue}>
                                    {this._renderNumbers(this._renderReach())}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.nextView !== "/signup/filter" &&
                        <div className={Styles.contentContainerRightItemInfo}>
                            <div className={Styles.contentContainerRightItemInfoAudience}>
                                <div>
                                    <div className={Styles.contentContainerRightItemInfoAudienceTitle}>
                                        {this._renderText("item_11")}
                                    </div>
                                    <div className={Styles.contentContainerRightItemInfoAudienceValue}>
                                        {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                        {
                                            this._renderNumbers(this._renderImpressionsBySpend())
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.contentContainerRightItemInfoLeads}>
                                <div>
                                    <div className={Styles.contentContainerRightItemInfoLeadsTitle}>
                                        {this._renderText("item_12")}
                                    </div>
                                    <div className={Styles.contentContainerRightItemInfoLeadsValue}>
                                        {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                        {
                                            this._renderNumbers(this._renderLeadsBySpend())
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        {
                            this.state.inhouse && this.state.nextView === "/signup/filter" &&
                            <div className={Styles.contentContainerRightItemInfo}>
                                <div className={Styles.contentContainerRightItemInfoAudience}>
                                    <div>
                                        <div className={Styles.contentContainerRightItemInfoAudienceTitle}>
                                            {this._renderText("item_11")}
                                        </div>
                                        <div className={Styles.contentContainerRightItemInfoAudienceValue}>
                                            {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                            {
                                                this._renderNumbers(this._renderImpressionsBySpend())
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={Styles.contentContainerRightItemInfoLeads}>
                                    <div>
                                        <div className={Styles.contentContainerRightItemInfoLeadsTitle}>
                                            {this._renderText("item_12")}
                                        </div>
                                        <div className={Styles.contentContainerRightItemInfoLeadsValue}>
                                            {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                            {
                                                this._renderNumbers(this._renderLeadsBySpend())
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={Styles.durationContainer}>
                            <div className={Styles.durationContainerTitle}>
                                {this._renderText("item_39")}
                            </div>
                            <div className={Styles.durationContainerValue}>
                                {
                                    (this.state.nextView !== "/signup/payment" && this.state.nextView !== "/signup/checkout" && this.state.durations.length > 1) &&
                                    <div onClick={() => this._decreaseDuration()} className={
                                        cx(Styles.channelsContainerItemTopPriceMinus,
                                            {
                                                [Styles.channelsContainerItemTopPriceMinusActive]: this.state.durations.indexOf(parseInt(this.state.duration)) > 0,
                                            })
                                    }>
                                        <img className={Styles.durationContainerValueMinusIcon}
                                            src={require("../../assets/images/minus_icon_white_small.png")}/>
                                    </div>
                                }
                                {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                {this.state.duration}&nbsp;{this._renderText("item_40")}
                                {
                                    (this.state.nextView !== "/signup/payment" && this.state.nextView !== "/signup/checkout" && this.state.durations.length > 1) &&
                                    <div onClick={() => this._increaseDuration()} className={
                                        cx(Styles.channelsContainerItemTopPricePlus,
                                            {
                                                [Styles.channelsContainerItemTopPricePlusActive]: this.state.durations.indexOf(parseInt(this.state.duration)) < this.state.durations.length - 1,
                                            })
                                    }>
                                        <img className={Styles.durationContainerValuePlusIcon}
                                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    </div>
                                }
                            </div>
                        </div>
                        {
                            false &&
                            <span>
                                <div className={Styles.divider}/>
                                <div className={Styles.channelsContainerAuto}>
                                    {
                                        this.state.channels &&
                                        Object.keys(this.state.channels).filter((item) => {
                                            return this.state.channels[item].selected
                                        }).sort((a, b) => this.state.channels[a].index > this.state.channels[b].index).map((key) => {
                                            return (
                                                <div key={key} className={Styles.channelsContainerItem}>
                                                    <div className={Styles.channelsContainerItemTop}>
                                                        <div className={Styles.channelsContainerAutoItemTopTitle}>
                                                            {key}
                                                        </div>
                                                        <div className={Styles.channelsContainerItemTopPrice}>
                                                            <img className={Styles.channelsContainerItemTopCheckmark}
                                                                 src={require("../../assets/images/checkmark-disabled.svg")}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </span>
                        }
                        <div className={Styles.divider}/>
                        {
                            this.state.channels &&
                            Object.keys(this.state.channels).filter((item) => {
                                return this.state.channels[item].selected && this.state.budget[item].auto
                            }).length > 0 &&
                            <div className={Styles.spendContainer}>
                                <div className={Styles.spendContainerTop}>
                                    <div className={Styles.durationContainerTitle}>
                                        {this._renderText("item_47")}
                                    </div>
                                    <div className={Styles.durationContainerValue}>
                                        {
                                            this.state.nextView !== "/signup/payment" &&
                                            <div onClick={() => this._decreaseAutoSpend()} className={
                                                cx(Styles.channelsContainerItemTopPriceMinus,
                                                    {
                                                        [Styles.channelsContainerItemTopPriceMinusActive]: this.state.spend > this.state.min && this.state.min !== this.state.max && this.state.regions.length > 0,
                                                    })
                                            }>
                                                <img className={Styles.durationContainerValueMinusIcon}
                                                     src={require("../../assets/images/minus_icon_white_small.png")}/>
                                            </div>
                                        }
                                        {
                                            this.state.regions.length > 0 &&
                                                <span>
                                                    {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                                {this._renderNumbers(Math.round(this.state.spend))}&nbsp;{this.state.currency.toUpperCase()}
                                                </span>
                                        }
                                        {
                                            this.state.regions.length < 1 &&
                                            <span>{"0"}&nbsp;{this.state.currency.toUpperCase()}</span>
                                        }
                                        {
                                            this.state.nextView !== "/signup/payment" &&
                                            <div className={
                                                cx(Styles.channelsContainerItemTopPricePlus,
                                                    {
                                                        [Styles.channelsContainerItemTopPricePlusActive]: this.state.spend < this.state.max && this.state.min !== this.state.max && this.state.regions.length > 0,
                                                    })
                                            } onClick={() => this._increaseAutoSpend()}>
                                                <img className={Styles.durationContainerValuePlusIcon}
                                                     src={require("../../assets/images/plus_sign_white_small.png")}/>
                                            </div>
                                        }
                                    </div>
                                </div>

                                {
                                    this.state.channels &&
                                    Object.keys(this.state.channels).filter((item) => {
                                        return this.state.channels[item].selected
                                    }).sort((a, b) => this.state.channels[a].index - this.state.channels[b].index).map((key) => {
                                        return (
                                            <div className={Styles.spendContainerBottom}>
                                                <div className={Styles.spendContainerBottomLeft}>
                                                    {this._renderChannelName(key)}
                                                </div>
                                                {
                                                    this.state.regions.length > 0 &&
                                                    <div className={Styles.spendContainerBottomRight}>
                                                        {this._renderNumbers(Math.round(this.state.budget[key].spend))}&nbsp;{this.state.currency}
                                                    </div>
                                                }
                                                {
                                                    this.state.regions.length < 1 &&
                                                    <div className={Styles.spendContainerBottomRight}>
                                                        {"0"}&nbsp;{this.state.currency}
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                        {
                            this.state.channels &&
                            Object.keys(this.state.channels).filter((item) => {
                                return this.state.channels[item].selected && this.state.budget[item].auto
                            }).length > 0 && !this.state.servicefee_fixed && !this.state.servicefee_percentage && this.state.lockin &&
                            <div className={cx(Styles.channelsContainer, Styles.channelsContainerDiscount)}>
                                <div className={Styles.channelsContainerItem}>
                                    <div className={Styles.channelsContainerItemTop}>
                                        <div
                                            className={cx(Styles.channelsContainerItemTopTitle, Styles.channelsContainerItemTopTitleGreen)}>
                                            {this._renderText("item_50")}
                                        </div>
                                        <div
                                            className={cx(Styles.channelsContainerItemTopPrice, Styles.channelsContainerItemTopTitleGreen)}>
                                            {this._renderDiscount() > 0 &&
                                            <span>-</span>}{this._renderNumbers(Math.round(this._renderDiscount()))}&nbsp;{this.state.currency}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.channels && (this.state.servicefee_fixed || this.state.servicefee_percentage) &&
                            Object.keys(this.state.channels).filter((item) => {
                                return this.state.channels[item].selected && this.state.budget[item].auto
                            }).length > 0 &&
                            <div className={Styles.serviceContainer}>
                                <div className={Styles.channelsContainerItem}>
                                    <div className={Styles.channelsContainerItemTop}>
                                        <div className={Styles.channelsContainerItemTopTitle}>
                                            {this._renderText("item_19")}
                                        </div>
                                        {
                                            this.state.servicefee_fixed &&
                                            <div className={Styles.channelsContainerItemTopPrice}>
                                                {this._renderNumbers(Math.round(this._renderFixedFee()))}&nbsp;{this.state.currency}
                                            </div>
                                        }
                                        {
                                            this.state.servicefee_percentage &&
                                            <div className={Styles.channelsContainerItemTopPrice}>
                                                {this._renderNumbers(Math.round(this._renderPercentageFee()))}&nbsp;{this.state.currency}
                                            </div>
                                        }
                                    </div>
                                    <div className={Styles.spendContainerBottom}>
                                        <div className={Styles.spendContainerBottomLeftNoCap}>
                                            {
                                                (this.state.servicefee_fixed || this.state.servicefee_percentage) && !this.state.lockin &&
                                                <span>{this.state.plan.title[langRegister.lang()]}</span>

                                            }
                                            {
                                                this.state.lockin &&
                                                <span>
                                                    {this._renderText("item_49")}&nbsp;{this.state.lockin_plan.months}
                                                </span>
                                            }
                                        </div>
                                        {
                                            this.state.lockin &&
                                            <div className={Styles.spendContainerBottomRight}>
                                                <span className={Styles.discount}>{this._renderDiscount() > 0 &&
                                                <span>-</span>}{this._renderNumbers(Math.round(this._renderDiscount()))}&nbsp;{this.state.currency}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            this.state.channels &&
                            Object.keys(this.state.channels).filter((item) => {
                                return this.state.channels[item].selected && this.state.budget[item].auto
                            }).length < 1 &&
                            <div className={Styles.channelsContainer}>
                                {
                                    this.state.channels &&
                                    Object.keys(this.state.channels).filter((item) => {
                                        return this.state.channels[item].selected
                                    }).sort((a, b) => this.state.channels[a].index - this.state.channels[b].index).map((key) => {
                                        return (
                                            <div key={key} className={Styles.channelsContainerItem}>
                                                <div className={Styles.spendContainerTop}>
                                                    <div className={Styles.channelsContainerItemTopTitle}>
                                                        <div className={Styles.channelsContainerItemTopTitleInner}>
                                                            {key}&nbsp;<span className={Styles.channelsContainerItemTopTitleSmall}>{this._renderChannelNameShort(key)}</span>&nbsp;{(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin) && <span>X&nbsp;{this.state.lockin_plan.months}</span>}
                                                        </div>
                                                    </div>
                                                    <div className={Styles.durationContainerValue}>
                                                        {
                                                            this.state.nextView !== "/signup/payment" &&
                                                            <div className={
                                                                cx(Styles.channelsContainerItemTopPriceMinus,
                                                                    {
                                                                        [Styles.channelsContainerItemTopPriceMinusActive]: this.state.budget[key].min_budget < this.state.budget[key].spend && this.state.budget[key].min_budget !== this.state.budget[key].budget,
                                                                    })
                                                            } onClick={() => this._decreaseSpend(key)}>
                                                                <img
                                                                    className={Styles.durationContainerValueMinusIcon}
                                                                    src={require("../../assets/images/minus_icon_white_small.png")}/>
                                                            </div>
                                                        }
                                                        {(!this.state.servicefee_percentage && !this.state.servicefee_fixed && this.state.lockin && this.state.nextView === "/signup/payment") && <span className={Styles.lockin}>{this.state.lockin_plan.months}&nbsp;X&nbsp;</span>}
                                                        {this._renderNumbers(Math.round(this.state.budget[key].spend))}&nbsp;{this.state.currency}
                                                        {
                                                            this.state.nextView !== "/signup/payment" &&
                                                            <div className={
                                                                cx(Styles.channelsContainerItemTopPricePlus,
                                                                    {
                                                                        [Styles.channelsContainerItemTopPricePlusActive]: this.state.budget[key].budget > this.state.budget[key].spend && this.state.budget[key].min_budget !== this.state.budget[key].budget,
                                                                    })
                                                            } onClick={() => this._increaseSpend(key)}>
                                                                <img
                                                                    className={Styles.durationContainerValuePlusIcon}
                                                                    src={require("../../assets/images/plus_sign_white_small.png")}/>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className={Styles.channelsContainerItemBottom}>
                                                    {Math.floor(this.state.budget[key].spend / this.state.duration)}&nbsp;{this.state.currency.toLowerCase()}&nbsp;/&nbsp;{this._renderText("item_41")}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    (this.state.servicefee_fixed || this.state.servicefee_percentage) &&
                                    <div className={Styles.channelsContainerItem}>
                                        <div className={Styles.channelsContainerItemTop}>
                                            <div className={Styles.channelsContainerItemTopTitle}>
                                                {this._renderText("item_19")}
                                            </div>
                                            {
                                                this.state.servicefee_fixed &&
                                                <div className={Styles.channelsContainerItemTopPrice}>
                                                    {this._renderNumbers(Math.round(this._renderFixedFee()))}&nbsp;{this.state.currency}
                                                </div>
                                            }
                                            {
                                                this.state.servicefee_percentage &&
                                                <div className={Styles.channelsContainerItemTopPrice}>
                                                    {this._renderNumbers(Math.round(this._renderPercentageFee()))}&nbsp;{this.state.currency}
                                                </div>
                                            }
                                        </div>
                                        <div className={Styles.spendContainerBottom}>
                                            <div className={Styles.spendContainerBottomLeftNoCap}>
                                                {
                                                    (this.state.servicefee_fixed || this.state.servicefee_percentage) && !this.state.lockin &&
                                                    <span>{this.state.plan.title[langRegister.lang()]}</span>

                                                }
                                                {
                                                    this.state.lockin &&
                                                    <span>
                                                    {this._renderText("item_49")}&nbsp;{this.state.lockin_plan.months}
                                                </span>
                                                }
                                            </div>
                                            {
                                                this.state.lockin &&
                                                <div className={Styles.spendContainerBottomRight}>
                                                <span className={Styles.discount}>{this._renderDiscount() > 0 &&
                                                <span>-</span>}{this._renderNumbers(Math.round(this._renderDiscount()))}&nbsp;{this.state.currency}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    !this.state.servicefee_fixed && !this.state.servicefee_percentage && this.state.lockin &&
                                    <div className={Styles.channelsContainerItem}>
                                        <div className={Styles.channelsContainerItemTop}>
                                            <div
                                                className={cx(Styles.channelsContainerItemTopTitle, Styles.channelsContainerItemTopTitleGreen)}>
                                                {this._renderText("item_50")}
                                            </div>
                                            <div
                                                className={cx(Styles.channelsContainerItemTopPrice, Styles.channelsContainerItemTopTitleGreen)}>
                                                {this._renderDiscount() > 0 &&
                                                <span>-</span>}{this._renderNumbers(Math.round(this._renderDiscount()))}&nbsp;{this.state.currency}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div className={Styles.divider}/>
                        <div className={Styles.vatContainer}>
                            {
                                this.state.nextView === "/signup/payment" &&
                                <div className={Styles.vatContainerTitle}>
                                    {this._renderText("item_21")}&nbsp;({+this.state.vat}%)
                                </div>
                            }
                            {
                                this.state.nextView === "/signup/payment" &&
                                <div className={Styles.vatContainerValue}>
                                    {this._renderNumbers(this._renderVat())}&nbsp;{this.state.currency.toUpperCase()}
                                </div>
                            }
                        </div>
                        <div className={Styles.priceContainer}>
                            <div className={Styles.priceContainerTitle}>
                                {this._renderText("item_22")}
                            </div>
                            <div className={Styles.priceContainerValue}>
                                {this._renderNumbers(this._renderPartialBudget())}&nbsp;{this.state.currency.toUpperCase()}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default Basket;


// WEBPACK FOOTER //
// ./src/components/basket/component.js